import { render, staticRenderFns } from "./showPDF.vue?vue&type=template&id=570f8586&scoped=true&"
import script from "./showPDF.vue?vue&type=script&lang=js&"
export * from "./showPDF.vue?vue&type=script&lang=js&"
import style0 from "./showPDF.vue?vue&type=style&index=0&id=570f8586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570f8586",
  null
  
)

export default component.exports